import { AuthHelper } from './helper';
import { tokenManager } from './token-manager';

// 认证模块统一入口
export { AuthHelper };
export { tokenManager };

// 兼容性导出（向后兼容）
export const TokenPrefix = 'Bearer ';

export function isLogin() {
  return tokenManager.isLoggedIn();
}

export async function getToken(): Promise<string> {
  const token = await AuthHelper.getValidToken();
  return token || '';
}

export function clearToken() {
  tokenManager.clear();
}
